import award from './award.png';

export default `
# Розыгрыш 200.000 бонусных монет AGold

![image info](${award})
Примите участие в розыгрыше и получите возможность выиграть целый сундук бонусных монет от игровой платформы AG.ru

**Условия участия**

1. Зарегистрироваться на игровой платформе AG.ru

2. Совершить платеж на любую сумму в одной из представленных на платформе игр:<br>
[Боевая Арена](https://ag.ru/games/battle-arena)<br>
[Fanwars](https://ag.ru/games/fanwars)<br>
[Арена Легенд](https://ag.ru/games/arena-legend)<br>
[Хранители Карт и Магии](https://ag.ru/games/khraniteli-kart-i-magii)

3. Подтвердить свое участие и прислать свой никнейм на платформе в чат одного из наших сообществ:<br>
[Телеграм](https://t.me/agru_gameplatform/1674)<br>
[Дискорд](https://discord.gg/SpyScEAUeV)<br>
[Вконтакте](https://vk.com/topic-36403380_50015507)<br>

**Призы**

5 победителей разделят между собой 200.000 бонусных монет AGold:

1 место – 100.000 бонусных монет AGold

2 место – 50.000 бонусных монет AGold

3 место – 25.000 бонусных монет AGold

4 место – 15.000 бонусных монет AGold

5 место – 10.000 бонусных монет AGold

**Сроки проведения**

Старт – 6 октября, 15:00 по МСК

Окончание – 31 октября, 23:59 по МСК

**Подведение итогов**

Подведение итогов и выбор победителя состоится 1 ноября. Мы объявим победителя в 15:00 по МСК в сообществах платформы AG.ru (участвуют все, кто подтвердил свое участие до 23:59 по МСК, 31 октября)

Победитель будут выбраны рандомно, с помощью сервиса https://youtogift.com/ru/random, а итоги опубликованы в видео формате.

Победитель будет уведомлен о победе через почту и личные сообщения в той социальной сети, где он подтвердит участие в розыгрыше.

**Начисление награды**

Награда победителю будет начислена в течение 6 часов после объявления итогов розыгрыша.

**Примечания**

1. Сумма платежа для участия может быть любой.

2. Для участие в розыгрыше достаточно сделать один платеж в указанных выше играх, но если участник хочет повысить свои шансы на победу – он можете совершать дополнительные платежи в момент проведения акции. Каждый платеж будет фиксироваться в списке розыгрыша. Например, если участник сделает 5 платежей, его никнейм 5 раз попадет список.

3. Подтверждение для каждого последующего платежа (кроме первого) не требуется.

4. AGold – это бонусные монеты платформы AG.ru, 1 AGold = 1 рублю. Если монеты AGold есть на счету, они автоматически будут вычитаться из стоимости внутриигровых покупок при платежах в онлайн-играх. Максимальная скидка в монетах AGold составляет 50% от стоимости заказа.

По всем возникшим вопросам можно связаться с нами через [Обратную связь](https://ag.ru/feedback) или в сообществах игровой платформы: [Телеграм](https://t.me/agru_gameplatform), [Дискорд](https://discord.gg/RmNhGDWDxp), [Вконтакте](https://vk.com/absolute_games).

Желаем всем удачи!
`;
